import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 view-tenant-review-report" }
const _hoisted_2 = { class: "row details" }
const _hoisted_3 = { class: "col-lg-12 pb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Location", -1)
const _hoisted_5 = { class: "sub-text d-block" }
const _hoisted_6 = { class: "col-lg-3 pb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move In Date", -1)
const _hoisted_8 = { class: "sub-text d-block" }
const _hoisted_9 = { class: "col-lg-3 pb-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Move Out Date", -1)
const _hoisted_11 = { class: "sub-text d-block" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-2" }, null, -1)
const _hoisted_13 = { class: "col-lg-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "title d-block" }, "Date Submitted", -1)
const _hoisted_15 = { class: "sub-text d-block" }
const _hoisted_16 = { class: "ratings-overview d-flex align-items-center justify-content-between pt-5" }
const _hoisted_17 = { class: "d-flex flex-column" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Overall Rating", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fas fa-envelope" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Email Report ")
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "dropdown d-inline-block" }
const _hoisted_23 = ["data-kt-indicator"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-download" }),
  /*#__PURE__*/_createTextVNode(" Download ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Downloading... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "dropdown-menu" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Download Ledger", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item",
  href: "#"
}, "Download Report", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "ratings" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Report", -1)
const _hoisted_34 = { class: "text d-flex" }
const _hoisted_35 = { class: "me-3" }
const _hoisted_36 = { class: "d-block" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = {
  key: 2,
  class: "text-answer w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_EmailReportModal = _resolveComponent("EmailReportModal")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_LedgerReport = _resolveComponent("LedgerReport")!
  const _component_PDFGenerator = _resolveComponent("PDFGenerator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.address), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.move_in_date)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.move_out_date)), 1)
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.dateFormat(_ctx.currentTenantReview?.date_created)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_el_rate, {
          class: "review-ans-avrg",
          "model-value": _ctx.currentTenantReview?.average_rating,
          disabled: "",
          "allow-half": ""
        }, null, 8, ["model-value"])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-lg btn-new-design-primary",
          style: {"margin-right":"19px"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSendReport && _ctx.handleSendReport(...args)))
        }, _hoisted_21),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("button", {
            class: "btn btn-new-design-secondary dropdown-toggle",
            "data-kt-indicator": _ctx.generatingReport ? 'on' : null,
            type: "button",
            "data-bs-toggle": "dropdown",
            "aria-expanded": "false"
          }, _hoisted_26, 8, _hoisted_23),
          _createElementVNode("ul", _hoisted_27, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.download('ledger')))
            }, _hoisted_29),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.download('report')))
            }, _hoisted_31)
          ])
        ])
      ]),
      _createVNode(_component_EmailReportModal, {
        modelValue: _ctx.sendReport,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.sendReport) = $event)),
        onSend: _ctx.emailReport,
        ref: "emailReport",
        loading: _ctx.sendingReport
      }, null, 8, ["modelValue", "onSend", "loading"])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentTenantReview?.review_answers, (answer, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "rating-item w-100 d-flex justify-content-between flex-wrap"
        }, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, _toDisplayString(key + 1) + ".)", 1),
            _createElementVNode("span", _hoisted_36, _toDisplayString(answer.question), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["answer", { 'is-text': answer.type == 'textbox' }])
          }, [
            (answer.type === 'rating')
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_component_el_form_item, {
                    prop: answer.id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_rate, {
                        disabled: "",
                        size: "small",
                        class: "rating-size",
                        modelValue: answer.answer,
                        "onUpdate:modelValue": ($event: any) => ((answer.answer) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop"])
                ]))
              : (answer.type === 'radio')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", _ctx.getColor(answer.answer)])
                    }, _toDisplayString(answer?.answer), 3)
                  ]))
                : (answer.type === 'textbox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(answer.answer), 1))
                  : _createCommentVNode("", true)
          ], 2)
        ]))
      }), 128))
    ]),
    _createVNode(_component_PDFGenerator, {
      onGeneratingReport: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generatingReport = true)),
      onGeneratedReport: _cache[5] || (_cache[5] = ($event: any) => (_ctx.generatingReport = false)),
      orientation: "portrait",
      "file-name": "Report",
      ref: "pdfReport"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_LedgerReport, {
          "average-rating": _ctx.averageRating,
          info: _ctx.currentTenantReview
        }, null, 8, ["average-rating", "info"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_PDFGenerator, {
      onBeforeDownload: _ctx.handleBeforeDownload,
      enableDownload: false,
      previewModal: false,
      pdfFile: _ctx.pdfFile,
      orientation: "portrait",
      "file-name": _ctx.currentTenantReview.reference_no,
      ref: "senfPdfReport"
    }, {
      content: _withCtx(() => [
        _createVNode(_component_LedgerReport, {
          "average-rating": _ctx.averageRating,
          info: _ctx.currentTenantReview
        }, null, 8, ["average-rating", "info"])
      ]),
      _: 1
    }, 8, ["onBeforeDownload", "pdfFile", "file-name"])
  ]))
}